<script setup lang="ts">
defineOptions({
  name: 'MopHeaderMobileMenuSlider',
});

defineProps({
  activeLevel: {
    type: Number,
    required: true,
  },
});
</script>

<template>
  <div :class="['mobile-menu-slider', `mobile-menu-slider--level-${activeLevel}`]">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.mobile-menu-slider {
  display: flex;
  position: relative;
  transition: transform custom-metric(animation, transition-speed) ease;
  // Number of levels * 100%
  width: 400%;
}

// assumig there will be only 3 levels of depth in menu

@for $block-size from 0 through 3 {
  $translateXPercentage: $block-size * (-25%);
  .mobile-menu-slider--level-#{$block-size} {
    transform: translateX(#{$translateXPercentage});
  }
}
</style>
